import React from 'react'
import CollapsibleAttributeTree from './CollapsibleAttributeTree'

const CollapsibleRadio = (props) => <CollapsibleAttributeTree mode="radio" {...props} />

export default CollapsibleRadio
